import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { formatWeekLabel } from './helpers';

type Props = {
  startDate: Date;
  onPrev: () => void;
  onNext: () => void;
};

const WeekNav = ({ startDate, onPrev, onNext }: Props) => (
  <div className="week-nav">
    <button
      type="button"
      className="week-nav-btn"
      aria-label="View previous week"
      onClick={onPrev}
    >
      <FontAwesomeIcon icon={faChevronLeft} fixedWidth />
    </button>
    <div className="week-label">{formatWeekLabel(startDate)}</div>
    <button
      type="button"
      className="week-nav-btn"
      aria-label="View next week"
      onClick={onNext}
    >
      <FontAwesomeIcon icon={faChevronRight} fixedWidth />
    </button>
  </div>
);

export default WeekNav;
